import grind from '../assets/animations/grind.json'
import boil from '../assets/animations/boil.json'

// V60
import v601 from '../assets/animations/V60/01-V60.json'
import v602 from '../assets/animations/V60/02-V60.json'
import v603 from '../assets/animations/V60/03-V60.json'
import v604 from '../assets/animations/V60/04-V60.json'
import v605 from '../assets/animations/V60/05-V60.json'
import v606 from '../assets/animations/V60/06-V60.json'
import v607 from '../assets/animations/V60/07-V60.json'

// Origami
// import origami1 from '../assets/animations/origami/01-origami.json'
// import origami2 from '../assets/animations/origami/02-origami.json'
// import origami3 from '../assets/animations/origami/03-origami.json'
// import origami4 from '../assets/animations/origami/04-origami.json'
// import origami5 from '../assets/animations/origami/05-origami.json'

// French
import french1 from '../assets/animations/french/01-french.json'
import french2 from '../assets/animations/french/02-french.json'
import french3 from '../assets/animations/french/03-french.json'
import french4 from '../assets/animations/french/04-french.json'
import french5 from '../assets/animations/french/05-french.json'
import french6 from '../assets/animations/french/06-french.json'
import french7 from '../assets/animations/french/07-french.json'
import french8 from '../assets/animations/french/08-french.json'

// Cupping
import cupping3 from '../assets/animations/cupping/03-cupping.json'
import cupping4 from '../assets/animations/cupping/04-cupping.json'
import cupping5 from '../assets/animations/cupping/05-cupping.json'
import cupping6 from '../assets/animations/cupping/06-cupping.json'
import cupping7 from '../assets/animations/cupping/07-cupping.json'
import cupping9 from '../assets/animations/cupping/09-cupping.json'
import cupping10 from '../assets/animations/cupping/10-cupping.json'

// Espresso
import espresso1 from '../assets/animations/espresso/01-espresso.json'
import espresso2 from '../assets/animations/espresso/02-espresso.json'
import espresso3 from '../assets/animations/espresso/03-espresso.json'
import espresso4 from '../assets/animations/espresso/04-espresso.json'
import espresso5 from '../assets/animations/espresso/05-espresso.json'
import espresso6 from '../assets/animations/espresso/06-espresso.json'
import espresso7 from '../assets/animations/espresso/07-espresso.json'

// Aeropress
import aero1 from '../assets/animations/aero/01-aero.json'
import aero2 from '../assets/animations/aero/02-aero.json'
import aero3 from '../assets/animations/aero/03-aero.json'
import aero4 from '../assets/animations/aero/04-aero.json'
import aero5 from '../assets/animations/aero/05-aero.json'
import aero6 from '../assets/animations/aero/06-aero.json'
import aero7 from '../assets/animations/aero/07-aero.json'
import aero8 from '../assets/animations/aero/08-aero.json'

const navigations = [{
  icon: '/images/espresso.svg',
  key: 'espresso-roast',
  name: 'Espresso Roast',
  methods: [{
    icon: '/images/method-espresso.svg',
    key: 'espresso-machine',
    name: 'Espresso (Machine)',
    details: {
      roastLevel: 'Espresso',
      brewMethod: 'Espresso Machine',
      grindRange: 'Fine',
      time: 25,
    },
    quantities: [{
      coffee: 18,
      temp: '-',
      water: 40,
    }],
    steps: [{
      direction: 'Grind %coffee%g of coffee (fine)',
      animation: grind,
    }, {
      direction: 'Distribute the coffee in the portafilter before tamping',
      animation: espresso1,
    }, {
      direction: 'Apply medium force while tamping',
      animation: espresso2,
    }, {
      direction: 'Purge the grouphead before inserting the portafilter',
      animation: espresso3,
    }, {
      direction: 'Insert portafilter and place your cup and scale underneath',
      animation: espresso4,
    }, {
      direction: 'Press the extraction button. Aim to extract 40ml. (25 seconds)',
      animation: espresso5,
      time: 25,
    }, {
      direction: 'Remove scale and cup',
      animation: espresso6,
    }, {
      direction: 'Stir your espresso. Enjoy your coffee.',
      animation: espresso7,
    }],
  }, {
    icon: '/images/method-frenchpress.svg',
    key: 'french-press',
    name: 'French Press',
    details: {
      roastLevel: 'Filter/Espresso',
      brewMethod: 'French Press',
      grindRange: 'Coarse',
      time: 540,
    },
    quantities: [{
      coffee: 20,
      temp: '100°C',
      water: 300,
    }, {
      coffee: 30,
      temp: '100°C',
      water: 450,
    }, {
      coffee: 40,
      temp: '100°C',
      water: 600,
    }, {
      coffee: 50,
      temp: '100°C',
      water: 750,
    }],
    steps: [{
      direction: 'Boil water up to 100°C and preheat french press',
      animation: boil,
    }, {
      direction: 'Grind %coffee%g of coffee (coarse)',
      animation: grind,
    }, {
      direction: 'Add %coffee%g of coffee into the french press',
      animation: french1,
    }, {
      direction: 'Pour up to %water%ml of water',
      animation: french2,
    }, {
      direction: 'Leave to brew for 4 minutes',
      animation: french3,
      time: 240,
    }, {
      direction: 'Take a spoon and gently stir 5 times',
      animation: french4,
    }, {
      direction: 'Remove crust (foam) sitting on top of the brew',
      animation: french5,
    }, {
      direction: 'Slowly plunge the press down',
      animation: french6,
    }, {
      direction: 'Leave to brew for another 5 minutes',
      animation: french7,
      time: 300,
    }, {
      direction: 'Pour the coffee into the mug. Enjoy your coffee.',
      animation: french8,
    }],
  }],
}, {
  icon: '/images/filter.svg',
  key: 'filter-roast',
  name: 'Filter Roast',
  methods: [{
    icon: '/images/method-v60.svg',
    key: 'hario-v60',
    name: 'Hario v60',
    details: {
      roastLevel: 'Filter',
      brewMethod: 'Vario V60',
      grindRange: 'Medium-Fine',
      time: 150,
    },
    quantities: [{
      coffee: 15,
      temp: '93°C',
      water: 240,
      water1: 60,
      water2: 60,
      water3: 60,
      water4: 60,
    }, {
      coffee: 30,
      temp: '94°C',
      water: 450,
      water1: 100,
      water2: 100,
      water3: 125,
      water4: 125,
    }, {
      coffee: 45,
      temp: '96°C',
      water: 675,
      water1: 125,
      water2: 175,
      water3: 175,
      water4: 200,
    }],
    steps: [{
      direction: 'Boil water up to %temp%',
      animation: boil,
    }, {
      direction: 'Grind %coffee%g of coffee (medium-fine)',
      animation: grind,
    }, {
      direction: 'Rinse filter',
      animation: v601,
    }, {
      direction: 'Add %coffee%g of coffee into the dripper',
      animation: v602,
    }, {
      direction: 'Pour %water1%ml of water',
      animation: v603,
    }, {
      direction: 'Bloom 30 secs; Stir with spoon or brew stick',
      animation: v604,
      time: 30,
    }, {
      direction: 'Pour another %water2%ml of water (30 seconds)',
      animation: v605,
      time: 30,
    }, {
      direction: 'Pour another %water3%ml of water (30 seconds)',
      animation: v605,
      time: 30,
    }, {
      direction: 'Pour another %water4%ml of water (30 seconds)',
      animation: v605,
      time: 30,
    }, {
      direction: 'Let it extract until 30 seconds',
      animation: v606,
      time: 30,
    }, {
      direction: 'Remove dripper from server',
      animation: v607,
    }, {
      direction: 'Enjoy your coffee',
      animation: french8
    }],
  }, {
    icon: '/images/method-frenchpress.svg',
    key: 'french-press',
    name: 'French Press',
    details: {
      roastLevel: 'Filter/Espresso',
      brewMethod: 'French Press',
      grindRange: 'Coarse',
      time: 540,
    },
    quantities: [{
      coffee: 20,
      temp: '100°C',
      water: 300,
    }, {
      coffee: 30,
      temp: '100°C',
      water: 450,
    }, {
      coffee: 40,
      temp: '100°C',
      water: 600,
    }, {
      coffee: 50,
      temp: '100°C',
      water: 750,
    }],
    steps: [{
      direction: 'Boil water up to 100°C and preheat french press',
      animation: boil,
    }, {
      direction: 'Grind %coffee%g of coffee (coarse)',
      animation: grind,
    }, {
      direction: 'Add %coffee%g of coffee into the french press',
      animation: french1,
    }, {
      direction: 'Pour up to %water%ml of water',
      animation: french2,
    }, {
      direction: 'Leave to brew for 4 minutes',
      animation: french3,
      time: 240,
    }, {
      direction: 'Take a spoon and gently stir 5 times',
      animation: french4,
    }, {
      direction: 'Remove crust (foam) sitting on top of the brew',
      animation: french5,
    }, {
      direction: 'Slowly plunge the press down',
      animation: french6,
    }, {
      direction: 'Leave to brew for another 5 minutes',
      animation: french7,
      time: 300,
    }, {
      direction: 'Pour the coffee into the mug. Enjoy your coffee.',
      animation: french8,
    }],
  }, 
    {
      icon: '/images/method-cupping.svg',
      key: 'cupping',
      name: 'Cupping',
      details: {
        roastLevel: 'Filter',
        brewMethod: 'Cupping',
        grindRange: 'Medium - Medium Coarse',
        time: 540,
      },
      quantities: [{
        coffee: 10,
        temp: '94°C',
        water: 181,
      }],
      steps: [{
        direction: 'Boil water up to 94°C',
        animation: boil,
      }, {
        direction: 'Grind %coffee%g of coffee (medium-medium coarse)',
        animation: grind,
      }, {
        direction: 'Assess aroma from grounds',
        animation: cupping3,
      }, {
        direction: 'Tare and start timer; pour up to 180ml of water; ensure all the grounds are well saturated',
          animation: cupping4,
      }, {
        direction: 'Let the brew sit for 9 minutes',
          animation: cupping5,
        time: 540,
      }, {
        direction: 'Stir the brew gently three times with a spoon; assess the aroma from the brew for every stir given',
          animation: cupping6,
      }, {
        direction: 'Remove the crust using 2 spoons and ensure no foam is left on top of the brew',
          animation: cupping7,
      }, {
        direction: 'Let the brew sit for an additional 4-5 minutes if brew is still too hot',
          animation: french4,
          time: 240,
      }, {
        direction: 'Using a spoon, take and sip small amounts from the brew; you can try slurping',
          animation: cupping9,
      }, {
        direction: 'Enjoy your cupping experience.',
        animation: cupping10,
      }],
    },
  {
    icon: '/images/method-aeropress.svg',
    key: 'aeropress',
    name: 'Aeropress',
    details: {
      roastLevel: 'Filter',
      brewMethod: 'Aeropress',
      grindRange: 'Medium-Fine',
      time: 120,
    },
    quantities: [{
      coffee: 14,
      temp: '92°C',
      water: 200,
    }, {
      coffee: 36,
      temp: '92°C',
      water: 215,
    }],
    steps: [{
      direction: 'Boil water up to 92°C',
      animation: boil,
    }, {
      direction: 'Grind %coffee%g of coffee (medium-fine)',
      animation: grind,
    }, {
      direction: 'Rinse filter and prepare inverted aeropress position',
      animation: aero1,
    }, {
      direction: 'Add %coffee%g of coffee',
      animation: aero2,
    }, {
      direction: 'Pour %water%ml of water',
      animation: aero3,
    }, {
      direction: 'Stir with spoon or brew stick up to 30 seconds',
      animation: aero4,
      time: 30,
    }, {
      direction: 'Leave to brew for 1 minute',
      animation: aero5,
      time: 60,
    }, {
      direction: 'Screw in the filter cap, and invert onto mug/carafe',
      animation: aero6,
    }, {
      direction: 'Plunge for 30 seconds until you hear a hissing sound',
      animation: aero7,
      time: 30,
    }, {
      direction: 'Remove aeropress from server/mug',
      animation: aero8,
    }, {
      direction: 'Add 215ml of water to the extracted coffee',
      animation: aero8,
      condition: true,
    }, {
      direction: 'Enjoy your coffee.',
      animation: aero8,
    }],
  }],
}];

const CUP_SET = 'CUP_SET';
const MODAL_SET = 'MODAL_SET';
const TIMER_SET = 'TIMER_SET';
const TRIGGER_SET = 'TRIGGER_SET';

const encode = data => Object.keys(data).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])).join('&');
const formatTimer = time => `${Math.floor(time % 3600 / 60).toString().padStart(2,'0')}:${Math.floor(time % 60).toString().padStart(2,'0')}`;
const replace = (text, direction) => {
  let replacedText = text;

  if (/%coffee%/.test(text)) {
    replacedText = text.replace(/%coffee%/, direction.coffee);
  }

  if (/%water%/.test(text)) {
    replacedText = text.replace(/%water%/, direction.water);
  }

  if (/%temp%/.test(text)) {
    replacedText = text.replace(/%temp%/, direction.temp);
  }

  if (/%water1%/.test(text)) {
    replacedText = text.replace(/%water1%/, direction.water1);
  }

  if (/%water2%/.test(text)) {
    replacedText = text.replace(/%water2%/, direction.water2);
  }

  if (/%water3%/.test(text)) {
    replacedText = text.replace(/%water3%/, direction.water3);
  }

  if (/%water4%/.test(text)) {
    replacedText = text.replace(/%water4%/, direction.water4);
  }

  return replacedText;
}

export {
  navigations,

  encode,
  formatTimer,
  replace,

  CUP_SET,
  MODAL_SET,
  TIMER_SET,
  TRIGGER_SET,
};
